/**
 * 检查字符串是否不为空
 *
 * 该函数用于验证给定的字符串值是否为空（即trim()后是否为空字符串）如果字符串为空，则通过回调函数返回一个错误对象，
 * 用于在表单验证等场景中提示用户输入不能为空
 *
 * @param {Object} rule - 验证规则对象，通常由表单验证库提供
 * @param {string} value - 待验证的字符串值
 * @param {Function} callback - 回调函数，用于返回错误对象或表示校验通过
 * @param {string} message - 错误消息，当字符串为空时将通过回调函数返回
 */
export function checkNotBlank(rule, value, callback, message) {
    if (value == null){
       return callback(new Error(message))
    }
    let val = value.toString();
    if (val.trim()==''){
        return callback(new Error(message))
    }
    return callback()
}

export function checkNotInt(rule, value, callback, message) {
    if (value == null){
        return callback(new Error(message))
    }
    let val = value.toString();
    let reg = /^(0|-?[1-9]\d{0,8})$/
    if (!reg.test(val)){
        return callback(new Error(message))
    }
    return callback()
}

export function checkNotPlusInt(rule, value, callback, message) {
    if (value == null){
        return callback(new Error(message))
    }
    let val = value.toString();
    let reg = /^(0|-?[1-9]\d{0,8})$/
    if (!reg.test(val)){
        return callback(new Error(message))
    }
    if (Number(val) <= 0){
        return callback(new Error(message))
    }
    return callback()
}

export function checkNotZeroOrPlusInt(rule, value, callback, message) {
    if (value == null){
        return callback(new Error(message))
    }
    let val = value.toString();
    let reg = /^(0|-?[1-9]\d{0,8})$/
    if (!reg.test(val)){
        return callback(new Error(message))
    }
    if (Number(val) < 0){
        return callback(new Error(message))
    }
    return callback()
}

export function checkNotDecimal(rule, value, callback, message) {
    if (value == null) {
        return callback(new Error(message))
    }
    let val = value.toString();
    let reg = /^(0|-?[1-9]\d{0,8})(\.\d{1,2})?$/
    if (!reg.test(val)) {
        return callback(new Error(message))
    }
    return callback()
}

export function checkNotPlusDecimal(rule, value, callback, message) {
    if (value == null) {
        return callback(new Error(message))
    }
    let val = value.toString();
    let reg = /^(0|-?[1-9]\d{0,8})(\.\d{1,2})?$/
    if (!reg.test(val)) {
        return callback(new Error(message))
    }
    if (Number(val) <= 0){
        return callback(new Error(message))
    }
    return callback()
}

export function checkNotZeroOrPlusDecimal(rule, value, callback, message) {
    if (value == null) {
        return callback(new Error(message))
    }
    let val = value.toString();
    let reg = /^(0|-?[1-9]\d{0,8})(\.\d{1,2})?$/
    if (!reg.test(val)) {
        return callback(new Error(message))
    }
    if (Number(val) < 0){
        return callback(new Error(message))
    }
    return callback()
}

export function checkExistBlank(rule, value, callback, message) {
    if (value == null){
        return callback(new Error(message))
    }
    let val = value.toString();
    if (val.trim()==''){
        return callback(new Error(message))
    }
    if (val.indexOf(' ') != -1 && val.indexOf('　') != -1){
        return callback(new Error(message))
    }
    return callback()
}